import PatientDetailsComponent from "../components/patient/landing/PatientDetails"

const PatientDetails = ({noWorkQ}) => {    

    return <>
        <PatientDetailsComponent noWorkQ={noWorkQ} />
    </>
}

export default PatientDetails